import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as quoteImportApi from '../api/quote-import';
import type { AnalyzeQuoteRequest, QuoteImportConfirmRequest } from '../api/quote-import';

export function useAnalyzeQuote() {
  return useMutation({
    mutationFn: (data: AnalyzeQuoteRequest | { eventId: string; documentId: string }) =>
      quoteImportApi.analyzeQuote(data),
  });
}

export function useConfirmQuoteImport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: QuoteImportConfirmRequest) => quoteImportApi.confirmQuoteImport(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expenses'] });
    },
  });
}
